import dynamic from "next/dynamic";

export const ServicesCards = dynamic(() => import("./component"));
